import React from 'react'
import {Barker} from "../components/marketing/Barker";

export const BarkerPage = () => {
    return (
        <Barker/>
    )
}
